import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useLocaleStore } from "@/stores/locale-store";
import nl from "./nl";
import fr from "./fr";
import en from "./en";
import tr from "./tr";

const messages: Record<string, Record<string, string>> = { nl, fr, en, tr };

export function useI18n() {
  const { locale } = storeToRefs(useLocaleStore());

  const t = (key: string, params?: Record<string, string>): string => {
    let text = messages[locale.value]?.[key] ?? messages["nl"][key] ?? key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(new RegExp(`\\{${k}\\}`, "g"), v);
      });
    }
    return text;
  };

  return { t, locale };
}
